import { useMemo } from 'react';
import { createProjectStatsMatrix } from '../helpers/ProjectPreviewHelper';
import { ProjectDailyStatsResponse } from '../../../../shared/models/projects/stats/ProjectDailyStatsResponse';
import { PeriodType } from '../../../../shared/types/prompt/PeriodType';

export const useProjectStatsMatrix = (
  isProjectDailyStatsLoading: boolean,
  isMonitorPromptsLoading: boolean,
  isEventsLoading: boolean,
  period: string | undefined,
  projectDailyStats: ProjectDailyStatsResponse
) =>
  useMemo(() => {
    if (isProjectDailyStatsLoading || isMonitorPromptsLoading || isEventsLoading || !period) {
      return {
        matrix: [],
        secondMatrix: [],
        colorsMap: new Map<string, string>(),
        colorsPalette: [],
      };
    }

    return createProjectStatsMatrix(period as PeriodType, projectDailyStats);
  }, [projectDailyStats, period, isProjectDailyStatsLoading, isMonitorPromptsLoading, isEventsLoading]);
